// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1__Zq","cls2":"ImpactHubModal-cls2_HDs ImpactHubModal-cls1__Zq"};